import { render, staticRenderFns } from "./FormElementParagraph.vue?vue&type=template&id=1df8ed2e"
import script from "./FormElementParagraph.vue?vue&type=script&lang=js"
export * from "./FormElementParagraph.vue?vue&type=script&lang=js"
import style0 from "./FormElementParagraph.vue?vue&type=style&index=0&id=1df8ed2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports